import classNames from 'classnames'

import * as styles from './DashboardSeverityDot.module.css'

function DashboardSeverityDot({ tone }) {
  return <span className={classNames(styles.dot, styles[tone])} />
}

export default DashboardSeverityDot
